import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const IntroStep = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<>
			<p className="text-base">{translation.description}</p>

			<p className="text-base">{translation.description2}</p>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		description:
			'You can now store personally identifiable information in Ledidi. This is done by using digital codelists, which are seamlessly integrated with your existing datasets.',
		description2:
			'The codelist must be explicitly enabled for each project you wish to use it in. Click next to see how.'
	},

	[LanguageType.Norwegian]: {
		description:
			'Du kan nå lagre personlig identifiserbar informasjon i Ledidi. Dette gjøres ved bruk av digitale kodelister, som integreres sømløst med dine eksisterende datasett.',
		description2:
			'Kodelisten må eksplisitt aktiveres for hvert prosjekt du ønsker å bruke den i, klikk videre for å se hvordan.'
	}
};
